import ChangeUserPasswordVue from "./ChangeUserPassword.vue";
import ForgottenPasswordRequestModal from "./ForgottenPasswordRequestModal.vue";

export default {
  install(Vue) {
    Vue.component("fp-forgotten-password", ForgottenPasswordRequestModal);
    Vue.component("fp-change-password", ChangeUserPasswordVue);
  },
};
